import React from 'react';
import { Link } from 'react-router-dom';

// A custom link component that scrolls to top when clicked
const ScrollToTopLink = ({ to, children, className }) => {
  const handleClick = () => {
    // Use a more aggressive approach with multiple attempts
    setTimeout(() => {
      // First attempt - immediate scroll with no smooth behavior
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Force immediate scroll without smooth animation
      });

      // Second attempt with a slight delay
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);

      // Third attempt with a longer delay for tricky cases
      setTimeout(() => {
        // Try to force scroll by using document.documentElement
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0; // For Safari
      }, 150);
    }, 0);
  };

  return (
    <Link to={to} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default ScrollToTopLink;